import $http from '@/resource';
import utils from '@/utils';
import Cache from '@/cache';

const $api = {};

/**
 * 获取单位基本信息
 *
 * @param {string} companyId 单位id
 *
 * @date 2018-10-17 09:56:10
 *
 * @returns {Promise<any>}
 */
$api.getCompanyInfo = (companyId)=>{
    let url = "company-info";
    if(companyId){
        url = `${url}/${companyId}`;
    }
    const promise = new Promise(resolve=>{
        $http.get(url).then(response=>{
            if (response.code === "200") {
                resolve(response.data);
            } else {
                utils.notice(response.msg, 'error');
            }
        });
    });
    return promise;
};

/**
 * 获取单位基本设置
 *
 * @param {string} companyId 单位id
 *
 * @date 2018-10-17 09:56:33
 *
 * @returns {Promise<any>}
 */
$api.getCompanySetting = (companyId)=>{
    let url = "company-setting";
    if(companyId){
        url = `${url}/${companyId}`;
    }
    const promise = new Promise(resolve=>{
        $http.get(url).then(response=>{
            if (response.code === "200") {
                resolve(response.data);
            } else {
                utils.notice(response.msg, 'error');
            }
        });
    });
    return promise;
};

/**
 * 更新单位基本设置
 *
 * @param {string} status 修改的状态
 *
 * @date 2018-10-17 09:57:12
 *
 * @returns {Promise<any>}
 */
$api.setCompanySetting = (status)=>{
    const url = "company-setting";
    const promise = new Promise(resolve=>{
        $http.patch(url,{"is_check_new":status}).then(response=>{
            if (response.code === "200") {
                resolve(response.data);
            } else {
                utils.notice(response.msg, 'error');
            }
        });
    });
    return promise;
};

/**
 * 获取单位图片
 *
 * @param {string} companyId 单位id
 *
 * @date 2018-10-17 09:57:27
 *
 * @returns {Promise<any>}
 */
$api.getCompanyPics = (companyId)=>{
    let url = 'company-img';
    if(companyId){
        url = `company-img/${companyId}`;
    }
    const promise = new Promise(resolve => {
        $http.get(url).then(response=>{
            if (response.code === "200") {
                resolve(response.data);
            } else {
                utils.notice(response.msg, 'error');
            }
        });
    });
    return promise;
};

/**
 * 单位编辑-保存
 *
 * @param {string} companyId 单位id
 * @param {object} data 待编辑的数据
 *
 * @date 2018-8-22 16:25:274
 *
 * @return promise
 */
$api.setCompanyBaseInfo = (companyId, data)=>{
    const url = "company-info/"+companyId;
    const promise = new Promise(resolve => {
        $http.put(url,data).then(response=>{
            // if (response.code === "200") {
                resolve(response);
            // } else {
            //     utils.notice(response.msg, 'error');
            // }
        });
    });
    return promise;
};

/**
 * 获取工业地产分类
 *
 * @param {string} companyId 单位id
 *
 * @date 2018-8-24 16:45:16
 *
 * @returns {Promise<any>}
 */
$api.getCompanyIndustrialTypes = (companyId="0")=>{
    const url = "company/"+companyId+"/industrial-types";
    const promise = new Promise(resolve => {
        $http.get(url).then(response=>{
            if (response.code === "200") {
                resolve(response.data);
            } else {
                utils.notice(response.msg, 'error');
            }
        });
    });
    return promise;
};

/**
 * 获取招商需求分类备选项
 *
 * @date 2018-8-25 16:50:21
 *
 * @returns {Promise<any>}
 */
$api.getCompanyBusinessTypes = ()=>{
    const url = "company/business-demand";
    const promise = new Promise(resolve => {
        $http.get(url).then(response=>{
            if (response.code === "200") {
                resolve(response.data);
            } else {
                utils.notice(response.msg, 'error');
            }
        });
    });
    return promise;
};

/**
 * 添加单位
 *
 * @param {object} data 待添加数据
 *
 * @return promise
 */
$api.addCompany = (data)=>{
    const url = "company";
    const promise = new Promise(resolve => {
        $http.post(url, data).then(response=>{
            // if (response.code === "200") {
                resolve(response);
            // } else {
                // utils.notice(response.msg, 'error');
            // }
        });
    });
    return promise;
};

export default $api;


// WEBPACK FOOTER //
// ./src/service/company/companyinfo.js